<template>
  <div id="app">
    <div id="nav">
      <navHeader />
    </div>
    <div class="content">
      <router-view />
    </div>
    <!-- 底部导航栏 -->
    <footerBar></footerBar>
  </div>
</template>

<script>
import navHeader from "./components/navHeader.vue";
import footerBar from "./components/footerBar.vue";

export default {
  data() {
    return {};
  },
  components: {
    navHeader,
    footerBar,
  },
};
</script>

<style lang="less" scoped>
.content {
  min-height: 80vh;
}
</style>
